import type { App } from 'vue';
import PtInputV1 from './components/input';
import PtPopup from './components/popup';
const components = [PtInputV1, PtPopup];

const install = (app: App): void => {
    components.forEach(component => {
        app.component(component.name, component);
    });
};

export default {
    install
};
